import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ConfigService } from 'src/app/shared/services/config.service';
import { ConfirmacionDialogComponent } from 'src/app/shared/components/confirmacion-dialog/confirmacion-dialog.component';
import { DatePipe, DecimalPipe } from '@angular/common'
import { ExcelService } from 'src/app/shared/services/excel.service';
import { isMobile, isMobileXL, toFormData } from 'src/app/shared/utils/helpers';
import { ItemParametro } from 'src/app/shared/models/itemparametro';
import { ItemsParametrosDialogComponent } from './items-parametros-dialog.component';
import { LoggedService } from 'src/app/shared/services/logged.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Parametro } from 'src/app/shared/models/parametro';
import { ParametrosService } from '../../../shared/services/parametros.service';
import { Router } from '@angular/router';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';

@Component({
  selector: 'app-items-parametros',
  templateUrl: './items-parametros.component.html'
})
export class ItemsParametrosComponent implements OnInit, AfterViewInit {

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private configService: ConfigService,
    private dialog: MatDialog,
    private loggedService: LoggedService,
    private parametroService: ParametrosService,
    private router: Router,
    private sidenav: SidenavService,
    private snackBarService: SnackbarService,
    public exporExcelService: ExcelService) { }
  botonReporte: string = "";
  displayedColumns = ['acciones', 'descripcionParametro', 'idItem', 'descripcion', 'habilitacion'];
  dataSource = new MatTableDataSource<ItemParametro>();
  itemsParametros: ItemParametro[] = [];
  parametros: Parametro[] = [];
  apiResponse: any = [];
  idParametroSeleccionado: number = -1;


  public Etiquetas: {
    Titulo: string
    SinRegistros: string
    Buscar: string
    BotonAItemParametro: string
    FiltrarParametro: string
    Headers: {
      Acciones: string,
      Descripcion: string,
      IdItem: string,
      Habilitacion: string,
      DescripcionParametro: string
    }
  }

  public Tooltips: {
    Eliminar: string
    Editar: string
    Ver: string;
  }


  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.sort.disableClear = true;

  }
  ngOnInit(): void {
    if (!this.loggedService.isInRole('ADM') && !this.loggedService.isInRole('ADMVENTAS') && !this.loggedService.isInRole('ADM LOCAL') && !this.loggedService.isInRole('CONTACT CENTER') && !this.loggedService.isInRole('CONSULTOR')) {
      this.router.navigateByUrl('');
    }
    this.botonReporte = this.configService.etiquetas.BotonReporte;
    this.Etiquetas = {
      BotonAItemParametro: this.configService.etiquetas.ItemsParametros.BotonAItemParametro,
      Buscar: this.configService.etiquetas.Buscar,
      SinRegistros: this.configService.etiquetas.SinRegistros,
      Titulo: this.configService.etiquetas.ItemsParametros.Titulo,
      FiltrarParametro: this.configService.etiquetas.ItemsParametros.FiltrarParametro,
      Headers: {
        Acciones: this.configService.etiquetas.Acciones,
        Descripcion: this.configService.etiquetas.Descripcion,
        Habilitacion: this.configService.etiquetas.Habilitacion,
        IdItem: this.configService.etiquetas.ItemsParametros.Headers.IdItem,
        DescripcionParametro: this.configService.etiquetas.ItemsParametros.Headers.DescripcionParametro
      }
    }

    this.Tooltips = {
      Editar: this.configService.tooltips.Editar,
      Eliminar: this.configService.tooltips.Eliminar,
      Ver: this.configService.tooltips.Ver
    }
    this.parametroService.cParametrosHabilitados().subscribe((data: Parametro[]) => {
      this.parametros = data;
    });
    this.buscar(0, -1);
  }

  buscar(idTipoMensaje: number, idParametro: number) {


    this.parametroService
      .cItemsParametros(idParametro)
      .subscribe((itemsParametros: ItemParametro[]) => {


        if (itemsParametros.length) {
          this.itemsParametros = [];
          this.itemsParametros = itemsParametros;
          this.dataSource.data = [];
          this.dataSource.data = this.itemsParametros;
          switch (idTipoMensaje) {
            case 1:
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.AltaExitosa, 1, 1)
              break;
            case 2:
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.ModificacionExitosa, 1, 1)
              break;
          }
        } else {
          this.dataSource.data = [];
        }

      })


  }


  cReporteExcel() {
    this.exporExcelService.cExcelReporteItemsParametros(this.dataSource.data);
  }

  dialogItemParametro(idTipo: number, p: ItemParametro) {

    let config: MatDialogConfig = new MatDialogConfig();
    config.width = '100%';
    config.height = 'auto';
    config.data = { itemParametro: p, idTipo: idTipo }
    let dialogRef = this.dialog.open(ItemsParametrosDialogComponent, config);
    dialogRef.afterClosed().subscribe((data: ItemParametro) => {
      if (data != null) {
        this.buscar(idTipo, this.idParametroSeleccionado);
      }

    })

  }
  eliminarItemParametro(ip: ItemParametro) {
    this.dialog
      .open(ConfirmacionDialogComponent, { panelClass: 'app-dialog', data: "¿Confirmas la eliminación del Ítem - Parámetro: " + ip.displayValue + "?", width: 'auto', height: 'auto' })
      .afterClosed()
      .subscribe((Si: boolean) => {
        if (Si) {
          this.parametroService.bItemParametro(ip).subscribe((i: ItemParametro) => {
            const index = this.itemsParametros.findIndex(c => c.idItem == i.idItem && c.idParametro == i.idParametro)
            this.itemsParametros.splice(index, 1)
            this.itemsParametros = [...this.itemsParametros]
            this.dataSource.data = [];
            this.dataSource.data = this.itemsParametros;

            this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.EliminacionExitosa, 1, 1)
          })
        }
      })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  compareParametros(a1: any, a2: any): boolean {
    return a1 && a2 ? a1 === a2 : a1 === a2;
  }

  onChange(idParametro: any) {
    this.idParametroSeleccionado = idParametro;
    this.buscar(0, this.idParametroSeleccionado);
  }
  toggleRightSidenav() {
    this.sidenav.toggle();
  }

  isLogged() {
    return this.loggedService.logged != null;
  }

  isNewUser() {
    if (this.loggedService.logged != null) {
      return this.loggedService.logged.newUser;
    }
    else {
      return false
    }
  }

  isMobileXL() {
    return isMobileXL();
  }

  isMobile() {
    return isMobile();
  }
  isInRole(rol: string): boolean {
    return this.loggedService.isInRole(rol);
  }
}
